import Drawer from '@mui/material/Drawer';
import {
  DRAWER_WIDTH,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerMainContainer
} from '../NRDashboardCharts/NRClickThroughDrawer/NRClickThroughDrawer';
import NRActivityFeedContainer from './NRActivityFeedContainer';

function NRActivityFeed({ openDrawer, handleClose }) {
  return (
    <Drawer
      PaperProps={{ sx: { width: DRAWER_WIDTH } }}
      anchor={'right'}
      open={openDrawer}
      variant={'temporary'}
      onClose={() => handleClose()}
      onKeyDown={event => {
        if (event.key === 'Escape') {
          handleClose();
        }
      }}
    >
      <DrawerMainContainer>
        <DrawerHeader drawerTitle={'Activity Feed'} handleClose={handleClose} />
        <DrawerContent>
          <NRActivityFeedContainer handleClose={handleClose} />
        </DrawerContent>
        <DrawerFooter hasBack={false} handleClose={handleClose} />
      </DrawerMainContainer>
    </Drawer>
  );
}
export default NRActivityFeed;
